import { useContext } from "react"

import { AuthContext } from "../components/contexts/AuthProvider"

export const useAuth = () => {
  return useContext(AuthContext)
}
